<template>
  <v-container fluid class="white black--text px-6" dark>
    <h2 class="text-center bold title-products text-uppercase grey--text text--darken-3 font-oswald">
      Nuestra selección de empanadas
    </h2>
    <v-row justify="center" v-for="category in getHomeCategories" :key="category.id">


      <v-col
          cols="12" sm="6" md="3"
          v-for="product in getProductsByCategory(category)"
          :key="product.id"
          class="zoom"
      >
        <v-card class="white black--text" flat>
            <v-img
                :src="product.image"
                class="ma-auto"
                align="center"
                max-height="150"
                contain
                eager
            >

            </v-img>

          <v-card-title
              class="font-oswald justify-center grey--text text--darken-3 font-weight-black pt-0 pb-1 px-0"
          >
            {{ product.name }}
          </v-card-title>


          <v-card-text class="font-raleway text-center grey--text text--darken-3 font-weight-thin white black--text mb-0 pb-0" style="min-height: 50px">
            {{ product.description }}
          </v-card-text>
          <v-card-text class="ma-0 text-center pa-1">
            <v-chip class="font-weight-bold grey--text text--darken-3">${{ product.price }}</v-chip>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductProvider from "../../providers/ProductCustomProvider.js";
import ProductCategoryProvider from "../../providers/ProductCategoryProvider.js";

export default {
  name: "HomeProducts",

  data() {
    return {
      categories: [],
      products: [],
      loading: false,
    };
  },
  created() {
    this.fetchCategories()
    this.fetchProducts()
  },
  computed: {
    getHomeCategories(){
      return this.categories.filter(c => c.homeGallery)
    },
    getProductsByCategory() {
      return category => {
        return this.products.filter(item => item.categories.some(c => c.id === category.id))
      }
    },
  },
  methods: {
    fetchCategories() {
      this.loading = true;
      ProductCategoryProvider.fetchProductCategory()
          .then((res) => {
            this.categories = res.data.fetchProductCategory;
          })
          .catch((error) => console.error(error))
          .finally(() => (this.loading = false));
    },
    fetchProducts() {
      this.loading = true;
      ProductProvider.fetchProductsHomeGallery()
          .then((res) => {
            this.products = res.data.productFetchHomeGallery;
          })
          .catch((error) => console.error(error))
          .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.title-products {
  font-size: 2em;
  margin-top: 30px;
  margin-bottom: 30px;
}

.name {
  font-size: 36px !important;
}

.description {
  font-size: 24px;
}

.zoom {
  transition: transform 0.2s;
}

.zoom:hover {
  transform: scale(
      1.1
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>
